import { Box, Grid, TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import TextInput from 'components/TextInput/TextInput';
import React, { useEffect, useMemo, useState } from 'react';
import { getAddressSuggestions } from 'store/location/services/getAddressSuggestions';
import { getBusinessContacts } from 'store/projects/services/getBusinessContacts';

function ContactAutocomplete({
  label = 'No label',
  name,
  required,
  options = [],
  value = null, // The value of the input
  onChange = () => {}, // Called when changing input value
  handleSelect = () => {}, // Called when an option is chosen
  // Which set of keys the options carry. The project dialog reuses this
  // component for the client contact (contact_*) and for the responsible site
  // manager (site_manager_*), whose options are shaped the same way.
  fieldPrefix = 'contact',
}) {
  const firstNameKey = `${fieldPrefix}_first_name`;
  const lastNameKey = `${fieldPrefix}_last_name`;
  const emailKey = `${fieldPrefix}_email`;
  const phoneKey = `${fieldPrefix}_phone`;

  return (
    <Autocomplete
      id="address-autocomplete"
      fullWidth
      getOptionLabel={(option) => option[firstNameKey] || option}
      // filterOptions={(x) => x}
      options={options}
      autoComplete
      disableClearable
      includeInputInList
      // filterSelectedOptions
      noOptionsText="Ei tuloksia"
      value={value}
      freeSolo
      onChange={(event, newValue) => {
        handleSelect(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        onChange(event);
      }}
      renderInput={(params) => (
        <TextInput
          label={label}
          name={name}
          fullWidth
          required={required}
          {...params}
          //   endAdornment={!searchText && <Icon path={mdiMagnify} size={1} />}
        />
      )}
      renderOption={(option) => {
        const name = option[firstNameKey] + ' ' + option[lastNameKey];
        let rest = '';
        if (option[emailKey]) {
          rest += option[emailKey];
        }
        if (option[phoneKey]) {
          if (rest.length > 0) {
            rest += ', ';
          }
          rest += option[phoneKey];
        }

        return (
          <Grid container key={option.key}>
            <Grid item xs>
              <Typography noWrap>{name}</Typography>
              <Typography noWrap style={{ fontSize: 'small' }}>
                {rest}
              </Typography>
            </Grid>
          </Grid>
        );
      }}
    />
  );
}

export default ContactAutocomplete;
